module.exports = __webpack_public_path__ + "static/img/img_7.28ce2df.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/images/img_7.webp
// module id = phil
// module chunks = 4